import React, { useState } from 'react';
import rollingstone from './Logos/rollingstonelogo.jpg';
import businessinsider from './Logos/businesinsiderlogo.jpg';
import bustle from './Logos/bdglogo.png';
import nyt from './Logos/New_york_times_logo_PNG1.png';
import onethree from './Logos/one37.jpg';
import complexnews from './Logos/complexnews.jpg';
import { AiOutlineSearch } from 'react-icons/ai'; // Search icon from react-icons
import { RingLoader } from 'react-spinners'; // Example loader from react-spinners
import axios from 'axios';

function Logos() {
  const [value, setValue] = useState(''); // Input value
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [results, setResults] = useState([]); // Search results
  const [hasSearched, setHasSearched] = useState(false); // Track if a search has been made

  // Handle search logic
  const handleSearch = async () => {
    if (!value.trim()) return; // Prevent empty searches
    setIsLoading(true); // Show loader
    setHasSearched(true); // Mark that a search has been initiated

    try {
      // Call the backend API
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/get-2-results`, {
        params: { keyword: value },
      });
      setResults(response.data); // Set search results
    } catch (error) {
      console.error('Error fetching search results:', error);
      setResults([]); // Clear results on error
    } finally {
      setIsLoading(false); // Hide loader
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    // Reset hasSearched and results when input is cleared
    if (!inputValue.trim()) {
      setHasSearched(false);
      setResults([]);
    }
  };

  return (
    <div>
      <div className="w-full max-w-xl mx-auto mb-4 sm: p-6">
      <div className='relative'>
      <div className="absolute -top-8 flex items-center space-x-2">
          <p className="text-orange-500 font-semibold text-sm">Try PressRequest free</p>
          <div className="text-orange-500">
            <span className="text-lg">⤵</span> {/* Downward-curving arrow */}
          </div>
        </div>

        <div className="relative group">
          {/* Animated border background */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-gradient-x"></div>

          {/* Input container */}
          <div className="relative flex items-center bg-white rounded-lg">
            <input
              type="text"
              value={value}
              onChange={handleInputChange}
              className="w-full py-4 pl-4 pr-12 text-gray-900 placeholder-gray-400 bg-white border-none rounded-lg focus:outline-none focus:ring-0"
              placeholder="e.g. what's your profession?"
            />
            <button
              onClick={handleSearch}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-blue-600 text-white rounded-md p-2 hover:bg-blue-700 focus:outline-none disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading ? (
                <RingLoader size={20} color="white" />
              ) : (
                <AiOutlineSearch className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>
        </div>
        {/* Results display */}
        {results.length > 0 && (
          <div className="mt-4 bg-white shadow-lg rounded-lg p-4">
            <ul>
              {results.map((result, index) => (
                <li key={index} className="py-2 border-b last:border-b-0">
                  <p className="text-sm font-medium">{result.title}</p>
                  <p className="text-sm text-gray-600">{result.description}</p>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* No results message */}
        {hasSearched && !isLoading && results.length === 0 && value.trim() && (
          <div className="mt-4 bg-white shadow-lg rounded-lg p-4">
            <p className="text-sm text-gray-500">No results found for "{value}"</p>
          </div>
        )}
      </div>

      {/* Section with logos */}
      <section class="px-5 bg-white text-black">
        <div class="mx-auto max-w-screen-xl px-4">
          <div className="hidden md:block">
            <h5 className="mb-8 text-2xl font-extrabold tracking-tight leading-tight text-center text-gray-700 text-black md:text-2xl">
              See postings from
            </h5>
            {/* Logos */}
            <div className="flex h-20 overflow-hidden space-x-16 mb-10 ">
              <div className="flex space-x-16 animate-loop-scroll group-hover:paused">
                <img loading="lazy" src={nyt} className="max-w-none" alt="Image 2" />
                <img loading="lazy" src={bustle} className="max-w-none" alt="Image 3" />
                <img loading="lazy" src={businessinsider} className="max-w-none" alt="Image 4" />
                <img loading="lazy" src={rollingstone} className="max-w-none" alt="Image 5" />
                <img loading="lazy" src={onethree} className="max-w-none" alt="Image 6" />
                <img loading="lazy" src={complexnews} className="max-w-none" alt="Image 7" />
              </div>
              <div className="flex space-x-16 animate-loop-scroll group-hover:paused" aria-hidden="true">
                <img loading="lazy" src={nyt} className="max-w-none" alt="Image 2" />
                <img loading="lazy" src={bustle} className="max-w-none" alt="Image 3" />
                <img loading="lazy" src={businessinsider} className="max-w-none" alt="Image 4" />
                <img loading="lazy" src={rollingstone} className="max-w-none" alt="Image 5" />
                <img loading="lazy" src={onethree} className="max-w-none" alt="Image 6" />
                <img loading="lazy" src={complexnews} className="max-w-none" alt="Image 7" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Logos;
